import React, { useContext, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//
// general components
import _ from 'lodash';
// import ScrollMenu from 'react-horizontal-scrolling-menu'
import ClassCard from './classesList/ClassCard';
import PerformanceCard from './classesList/PerformanceCard';
import PerformanceCardCFP from './classesList/PerformanceCardCFP';

import { parse, isEqual, endOfDay } from 'date-fns';

import { isLessonLocked } from '../../../utils/lessonLock';

//
// context
import { CourseContext } from '../ClassContent/CourseDetail.container';

//
// selectors
import * as courseSelectors from '../../../redux/selectors/course';
import { allowedReportDownload, allowedScoreToro, checkIfIsModularOrNot } from '../../../helpers/permissions';

const propTypes = {
  courseClasses: PropTypes.array,
};
function ClassesList(props) {
  const { courseClasses } = props;

  const { selectedClass, setSelectedClass, course } = useContext(CourseContext);

  const list = useRef();
  const scrolledToToday = useRef(false);
  const scrollCancelRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);

  //
  // A regra do cadeado vive inteira em src/utils/lessonLock.ts (curso adicional
  // nunca bloqueia; no principal, quem manda e o `status` da API, nunca a data
  // em `days`).
  //
  // Retorna 1 | 0 porque ClassCard compara `locked === 1`.
  const checkLockedClass = (classItem) => (isLessonLocked(classItem) ? 1 : 0);

  const animateScroll = (container, targetScrollLeft) => {
    const start = container.scrollLeft;
    const distance = targetScrollLeft - start;
    const duration = 1000;
    let startTime = null;
    let cancelled = false;
    let rafId;

    const easeOut = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

    const step = (timestamp) => {
      if (cancelled) return;
      if (!container || !container.parentNode) { cancelled = true; return; }
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      container.scrollLeft = start + distance * easeOut(progress);
      if (progress < 1) rafId = requestAnimationFrame(step);
    };

    rafId = requestAnimationFrame(step);
    return () => { cancelled = true; cancelAnimationFrame(rafId); };
  };

  const scrollToCurrentClass = () => {
    const current = document.querySelector('.lessons-item.current.unlocked');
    const todayExists = !!document.querySelector('.lessons-item.today');

    if (todayExists) {
      if (!scrolled) setScrolled(true);
      return undefined;
    }

    if (scrollCancelRef.current) scrollCancelRef.current();
    if (current && selectedClass && selectedClass.titulo && !scrolled) {
      const target = current.offsetLeft - list.current.clientWidth / 2 + current.clientWidth / 2;
      setScrolled(true);
      scrollCancelRef.current = animateScroll(list.current, target);
      return scrollCancelRef.current;
    }
    return undefined;
  };

  useEffect(() => {
    const cancel = scrollToCurrentClass();
    return () => cancel?.();
    // eslint-disable-next-line
  }, [selectedClass]);

  useEffect(() => {
    if (scrolledToToday.current || !courseClasses?.length || !list.current) return;
    if (scrollCancelRef.current) scrollCancelRef.current();
    const rafId = requestAnimationFrame(() => {
      const todayCard = document.querySelector('.lessons-item.today');
      if (!todayCard) return;
      scrolledToToday.current = true;
      const container = list.current;
      const target = todayCard.offsetLeft - container.clientWidth / 2 + todayCard.clientWidth / 2;
      scrollCancelRef.current = animateScroll(container, target);
    });
    return () => cancelAnimationFrame(rafId);
    // eslint-disable-next-line
  }, [courseClasses]);

  useEffect(() => {
    return () => setSelectedClass(undefined);
    // eslint-disable-next-line
  }, []);

  useEffect(()=>{
    if(course?.classes?.length > 0 && !checkIfIsModularOrNot(course?.title))
      setSelectedClass(course?.classes[0])
    // eslint-disable-next-line
  },[])

  const handleCurrentClass = (classItem) => {
    const days = _.get(classItem, 'days');

    //
    // just check it for classes with date
    if (days && days.length > 0) {
      days.forEach((day) => {
        const classDate = parse(day.date, 'dd/MM/yy', new Date());
        if (isEqual(endOfDay(new Date()), endOfDay(classDate))) {
          setSelectedClass(classItem);
        }
      });
    }
  };

  const renderClassList = () => {
    //
    // aux vars
    let renderedMocks = [];
    let count = 0
    return courseClasses.map((classItem, i) => {
      const locked = checkLockedClass(classItem);

      //
      // workaround to set the current class
      // based just on the date
      if (!scrolled) {
        handleCurrentClass(classItem);
      }

      if (classItem.simulado) {
        //
        // 1. check if this mock was already rendered
        // 2. if not, render and add to the renderedMocks state array
        if (!renderedMocks.includes(classItem.id_aula_simulado_grupo)) {
          renderedMocks.push(classItem.id_aula_simulado_grupo);
          count++;
          return (
            <ClassCard
                key={i}
                classItem={classItem}
                locked={locked}
                order={count}
            />
          );
        }
      } else {
        count++;
        return (
            <ClassCard
                key={i}
                classItem={classItem}
                locked={locked}
                order={count}
            />
        );
      }
      return false;
    });
  };

  return (
    <div ref={list} className="lessons-list">
      {allowedScoreToro(course?.id_course_category) && (
          <PerformanceCard key="CEA_CPA" />
      )}
      {allowedReportDownload(course?.id_course_category) && checkIfIsModularOrNot(course?.title) ? (
          <PerformanceCardCFP key="CFP" />
      ):null}
      {renderClassList()}
    </div>
  );
}

const mapStateToProps = (state, props) => ({
  courseClasses: courseSelectors.courseClasses(state, props),
});
const mapDispatchToProps = () => ({
  // getClassesLists: (courseId, next) => dispatch(courseActions.getClassesLists(courseId, next)),
});

ClassesList.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(ClassesList);
